import { MantineThemeOverride } from '@mantine/core';

export type SpoilerTheme = NonNullable<MantineThemeOverride['components']>['Spoiler'];

export const Spoiler: SpoilerTheme = {
  // todo: define
};
